export class GetDimensionError extends Error {
}
